/*eslint-disable*/
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';

import ItemStatus from '../../../common/roadmap/SingleItem/ItemStatus';
import Upvoters from '../../../common/feedbackEdit/Upvoters';
import PostThumbnail from '../../../common/post-thumbnail/PostThumbnail';


import './public-details.scss';

const DetailsSidebar = ({
    roadmapInfo,
    billingDetails,
}) => {
    const {
        category_emoji,
        category,
        upvoters,
        created_at,
    } = roadmapInfo;

    return (
        <div className="details-sidebar">
            <PostThumbnail
                thumnailLocation={'public'}
                billingDetails={billingDetails}
                roadmapPayload={roadmapInfo}
            />
            {/* status */}
            <p className="__label">Status</p>
            <ItemStatus itemInfo={roadmapInfo} roadmapDetails={true} />
            <br />
            {/* category */}

            <p className="__label">Category</p>
            <p className={`category-text`}>
                {(category_emoji && category) && (
                    <span style={{ marginRight: '4px' }}>{category_emoji}</span>
                )}
                {category}
            </p>
            <br />

            <div className="_contents">
                <p className="__label">Upvoters</p>
                <Upvoters upvoters={upvoters} />
                {/* <span>
                    {
                        roadmapInfo?.upvoters?.map((upvoter) => (
                            <div key={upvoter.email} style={{ marginBottom: '5px' }}>
                                <div className="avatar">
                                    {getAvatar(upvoter.name)}
                                </div>
                                {upvoter.name}
                            </div>
                        ))
                    }
                </span> */}
            </div>
            <br />

            {/* created at */}
            <p className="__label">Created At</p>
            <p className={`category-text`}>
                <Moment format="LL">
                    {roadmapInfo?.created_at && roadmapInfo?.created_at['$date']}
                </Moment>
            </p>

        </div>
    );
};

export default DetailsSidebar;
